import { Component } from "@angular/core";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: "app-footer",
    imports: [TranslateModule, RouterLink, RouterLinkActive],
    templateUrl: "./footer.component.html",
    styleUrl: "./footer.component.scss"
})
export class FooterComponent {}
